module.exports = __webpack_public_path__ + "img/compras_ouro.9d07b4c6.png";